'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconFloppyDiskStarArrowRight, iconFloppyDiskStarArrowRightTag } from '@ni/nimble-components/dist/esm/icons/floppy-disk-star-arrow-right';
import { wrap } from '../../utilities/react-wrapper';

export type { IconFloppyDiskStarArrowRight };
export { iconFloppyDiskStarArrowRightTag };
export const NimbleIconFloppyDiskStarArrowRight = wrap(IconFloppyDiskStarArrowRight);